import { Col, QRCode, Row, Space, Typography } from 'antd';
import React, { useEffect } from 'react';
import { useGetQrCodeStore } from './hooks/useGetQrCodeStore';
import { useDispatch, useSelector } from 'react-redux';
import { setTitle } from '../../redux/title/action';

export const ProfileStore = () => {
  const profile = useSelector((state) => state.info) || null;
  const qrCode = useGetQrCodeStore(profile);
  const dispatch = useDispatch();
  const storeName = profile ? profile.storeName : '-';

  useEffect(() => {
    dispatch(setTitle('ข้อมูลร้านค้า'));
  }, []);

  return (
    <div>
      <Row>
        <Col span={24}>
          <Space direction="vertical" align="center" style={{ width: '100%', marginTop: 20 }}>
            <QRCode value={qrCode || '-'} bordered={false} size={200} />
            <Typography.Text strong style={{ fontSize: 20 }}>
              ร้าน : {storeName}
            </Typography.Text>
          </Space>
        </Col>
      </Row>
    </div>
  );
};
